import React, { FC } from "react";
import Image from "next/image";
import HeroButton from "@components/HeroButton";

const ZohoHeader: FC = () => {
    return (
        <header className="max-w-6xl mx-auto px-4 lg:px-0 pt-4  bg-white ">
            <div className="flex flex-col lg:flex-row justify-center md:justify-between lg:py-20 pt-0">
                <div className="lg:w-1/2 w-full flex flex-col">
                    <div
                        className="text-green-700 bg-green-200 wati-top-green justify-center items-center lg:text-base font-bold flex flex-nowrap w-fit m-auto md:m-0 mt-10"
                        style={{ padding: "5px 12px", borderRadius: "50px", border: "0.5px solid rgb(9, 146, 80)" }}
                    >
                        <p className="lg:text-base text-xs">Whatsapp Zoho Integration</p>
                        <span className="wa-control-img">
                            <Image
                                alt="white-border"
                                height={24}
                                loading="lazy"
                                width={24}
                                src="https://assets.gallabox.com/gb-home/new-zapier/wa-w-whiteborder.svg"
                                className="ml-2"
                            />
                        </span>
                    </div>
                    <h1 className="flex flex-col lg:justify-start justify-center text-gray-600 lg:pt-4 md:text-4xl text-2xl text-center md:text-left mt-2">
                        Zoho WhatsApp Integration for Better Communication
                    </h1>
                    <p className="lg:py-10 py-4 lg:text-l font-normal text-center lg:text-left lg:text-gray-700 text-gray-600">
                        Gallabox helps you automate the engagement of your{" "}
                        <a href="https://go.zoho.com/lOM" target="_blank" rel="noreferrer" className="text-blue-500">
                            Zoho
                        </a>{" "}
                        contacts on WhatsApp, helping you meet them where they are.
                    </p>
                    <HeroButton buttontext="SignUp for Free" />
                    <div className="flex gap-4 px-2 lg:px-0 mt-6">
                        {["No credit card required", "No setup fee"].map((each) => {
                            return (
                                <div className="flex items-center gap-1 md:gap-2" key={each}>
                                    <img src="https://assets.gallabox.com/gb-home/content-with-image/grey-tick-circle.svg" alt="Gray checkmark" className="opacity-50" />
                                    <p className="head-points">{each}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="lg:w-1/2 w-full">
                    <Image width={576} height={417} loading="lazy" src="https://assets.gallabox.com/gb-home/zoho-compressed-header.png" alt="zoho-header-image" />
                </div>
            </div>
        </header>
    );
};

export default ZohoHeader;
